import { TeamDataObject } from "../DataStorage/TeamDataObject";
import { BuilderTypes } from "./BuilderTypes";
import { BuilderStorage } from "./BuilderStorage";
import { BuilderStorageConstants } from "./BuilderStorageConstants";

export class BuilderStorageHistory extends TeamDataObject {
    builderId: string;
    name: string;
    projectId?: string;
    builderType: BuilderTypes;
    majorVersion: number;
    minorVersion: number;
    revision: number;
    oldStorage: BuilderStorage;
    notes?: string;
    changeSetName: string = BuilderStorageConstants.LIVE_CHANGE_SET_NAME;

    constructor(oldStorage: BuilderStorage, notes?: string) {
        super();
        this.projectId = oldStorage.projectId;
        this.builderId = oldStorage.builderId;
        this.name = oldStorage.name;
        this.builderType = oldStorage.builderType;
        this.majorVersion = oldStorage.majorVersion;
        this.minorVersion = oldStorage.minorVersion;
        this.revision = oldStorage.revision;
        // todo: need to do a better job at clone here.
        this.oldStorage = { ...oldStorage };
        this.notes = notes;
        this.changeSetName = oldStorage.changeSetName;
    }
}
